module.exports = __webpack_public_path__ + "img/truck-fast-solid.e018a229.svg";